import React, { useState, useEffect } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./gridWithoutBorderHL.css";

const GridWithoutBorderHLPure = (props) => {
  const {
    skip, //Number pagination {0}
    take, //Number pagination {6}
    dataGrid, //Array information to grid
    titleRow1, //Header first column
    fieldRow1, //Body information row to first column
    styleCol1, //Class to td (col1) from table, especifies width
    titleRow2, //Body information row to second column
    fieldRow2, //Header second column
    filter, //True to filter grid
    onFilterChange, //Filter function to grid
    onSelectedItem, //Select information item grid
    styleCol2, //Class to td (col2) from table, especifies width
    column2Status, //True to active second column
    pagination, //True or false, true to add pagination
  } = props;
  const { t } = useTranslation();

  const initialDataState = {
    skip,
    take,
  };
  const [page, setPage] = useState(initialDataState);
  const mobileResolution = useMediaQuery("(max-width:720px)");
  const [selectedItem, setSelectedItem] = useState({});

  const SignRequestCellHeader = (props) => {
    const cellHeaderStyles = {
      color: "#427FBA",
      fontSize: "16px",
      fontWeight: 600,
      display: "flex",
      justifyContent: "center",
      fontFamily: "Quicksand",
    };
    return <span style={cellHeaderStyles}>{props.title}</span>;
  };

  const avatarCell = (props) => {
    return (
      <td className={styleCol1}>
        <Link
          to={{
            pathname: `/followup-contracts`,
            state: { dataItem: props.dataItem },
          }}
        >
          <div className="gridWithoutBorderHLPure-containerAvatar">
            <div className="gridWithoutBorderHLPure-detailsContainer">
              <span className="gridWithoutBorderHLPure-fieldSubtitle">
                {props.dataItem[fieldRow1]}
              </span>
            </div>
          </div>
        </Link>
      </td>
    );
  };

  const columnTwoCell = (props) => {
    return (
      <td className={styleCol2}>
        <Link
          to={{
            pathname: `/followup-contracts`,
            state: { dataItem: props.dataItem },
          }}
        >
          {/* /*Texto sacado con props.dataItem[fieldRow2]*/}
          <span>{props.dataItem[fieldRow2]}</span>
        </Link>
      </td>
    );
  };

  const gridColumnNoRecordsStyle = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
  };

  const onPageChange = (event) => {
    setPage(event.page);
  };

  useEffect(() => {
    onSelectedItem(selectedItem);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  useEffect(() => {
    setPage(initialDataState);
  }, [dataGrid]);
  return (
    <Grid
      className="gridWithoutBorderHLPure"
      data={dataGrid.slice(page.skip, page.take + page.skip)}
      reorderable
      skip={page.skip}
      take={page.take}
      pageable={pagination}
      total={dataGrid.length}
      onPageChange={onPageChange}
      filter={filter}
      onChangeFilter={onFilterChange}
    >
      <GridColumn
        field={fieldRow1}
        title={titleRow1}
        cell={avatarCell}
        headerCell={SignRequestCellHeader}
      />
      {column2Status ? (
        <GridColumn
          field={fieldRow2}
          title={titleRow2}
          cell={columnTwoCell}
          headerCell={SignRequestCellHeader}
        />
      ) : (
        ""
      )}
      <GridNoRecords>
        <span style={gridColumnNoRecordsStyle}>
          {t("configurationDomainPanel.notResults")}
        </span>
      </GridNoRecords>
    </Grid>
  );
};
export { GridWithoutBorderHLPure as default };
